import type { Term } from "domains/language/types";
import {
  createTermNames,
  discoverTermNames,
  homeTermNames,
  moderateTermNames,
  monitorTermNames,
  moreTermNames,
} from "domains/nav/helpers/buildMenuItems";

export const extractSubnavTerms = (translate: (value: Term) => string) => ({
  create: extractTerms(translate, createTermNames),
  discover: extractTerms(translate, discoverTermNames),
  home: extractTerms(translate, homeTermNames),
  moderate: extractTerms(translate, moderateTermNames),
  monitor: extractTerms(translate, monitorTermNames),
  more: extractTerms(translate, moreTermNames),
});

const extractTerms = <T extends readonly Term[]>(translate: (value: Term) => string, names: T) =>
  names.reduce<Record<T[number], string>>(
    (accumulator, next) => ({ ...accumulator, [next]: translate(next) }),
    {} as Record<T[number], string>,
  );
